import  { jwtServerInstance }  from '../index'
import {getTokenUser} from "@/lib/utils";
import qs from	'qs'

//查询所有数据字典项
export const getAllB2cBackCard = () => {
    return jwtServerInstance.request({
        url:'/b2cbackcard/all',
        method:'post'
    })
}


//查询所有数据字典项
export const getAllB2cBackCardSys = () => {
    return jwtServerInstance.request({
        url:'/b2cbackcard/sysall',
        method:'post'
    })
}

//查询所有数据字典项
export const getAllB2cBackInfos = () => {
    return jwtServerInstance.request({
        url:'/b2cbackcard/allbackInfo',
        method:'post'
    })
}

//查询所有数据字典项
export const addB2cBackTypeInfos = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbackcard/addbacktype',
        method:'post',
        data: qs.stringify({
            backTypeName: dialogForm.backTypeName,
            isBackPay: dialogForm.isBackPay
        })
    })
}

export const getBackCardWithBusiness=(queryform) =>{
    return jwtServerInstance.request({
        url:'/b2cbackcard/querybusiness',
        method:'post',
        data:qs.stringify({
            b2cUsersId:queryform.b2cUsersId,
            isPlateformAccount:queryform.isPlateformAccount
        })
    })
}

//参数配置列表查询接口
export const getB2cBackCard = (queryFrom, pagination) => {
    return jwtServerInstance.request({
        url:'/b2cbackcard/query',
        method:'post',
        data:qs.stringify({
            backName:queryFrom.backName,
            backCardNum:queryFrom.backCardNum,
            isPlateformAccount:queryFrom.isPlateformAccount,
            status:queryFrom.status,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//更新b2c_goods的一条数据记录
export const updateB2cBackCard = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbackcard/update',
        method:'post',
        data:dialogForm
    })
}

//更新b2c_goods的一条数据记录
export const updateB2cBackCardByIds = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbackcard/updatebyids',
        method:'post',
        data:dialogForm
    })
}

//更新b2c_goods的一条数据记录
export const updateB2cBackCardBatch = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbackcard/updatebatch',
        method:'post',
        data:dialogForm
    })
}

//新增一条b2c_goods数据记录
export const addB2cBackCard = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbackcard/add',
        method:'post',
        data:dialogForm
    })
}

//删除一条b2c_goods数据记录
export const deleteB2cBackCard = (deleteId) => {
    return jwtServerInstance.request({
        url:'/b2cbackcard/delete',
        method:'post',
        data:qs.stringify({
            id:deleteId
        })
    })
}
